import React from "react";
import Modal from "../../../Shared/Modal";

class PaymentModal extends React.Component {
  componentDidMount() {
    const { totalLicensePrice, onApprove } = this.props;
    paypal
      .Buttons({
        style: {
          color: "blue",
          shape: "pill",
        },
        createOrder: (data, actions) =>
          actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: `${totalLicensePrice}`,
                },
              },
            ],
          }),
        onApprove: (data, actions) => {
          actions.order.capture().then(() => onApprove());
        },
      })
      .render("#paypal");
  }

  setModal = (node) => (this.modal = node);

  render() {
    const { close, paymentPriceExplanation } = this.props;
    return (
      <Modal setModal={this.setModal} close={close}>
        <div className="auth-modal">
          <div className="auth-modal-header">Payment</div>
          <div className="payment-price-explanation">
            {paymentPriceExplanation}
          </div>
          <div id="paypal" />
        </div>
      </Modal>
    );
  }
}

export default PaymentModal;
